import { render, staticRenderFns } from "./supplementary.vue?vue&type=template&id=04671dc8"
import script from "./supplementary.vue?vue&type=script&lang=js"
export * from "./supplementary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports